module.exports = __webpack_public_path__ + "static/img/egg_r_21.93c3cd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_21.png
// module id = HPIi
// module chunks = 1